<template>
    <div class="guangfu-tongyi">
        <div class="con">
            <div class="Files-top">
						<div class="ic-left">
						<span>收益分析</span>
						</div>
						<div class="btns">
                              <el-button type="primary" class="last-el-button">导出</el-button>
						</div>
			</div>
            <div class="search-input-btn" style="width:100%">
           
               <div class="input-small myinput mr-20">
						<span>周期：</span>
						<el-select v-model="value" placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
		     	   </div>
					<div class="input-small ">
						<span>时间：</span>
						    <el-date-picker
                                v-model="value2"
                                :type="value"
                                placeholder="选择时间">
                                </el-date-picker>
						</div>
						<el-button type="primary" plain class="search-btn">查询</el-button>
			</div>
            <div class="myteble" :style="{'height':heights+'px'}">
                 <div id="middle3" style="width:100%;height:100%"></div>
            </div>

        </div>
    </div>
</template>

<script>
  let middle3;
export default {
    name: 'WedoWebEleEfficiency',

    data() {
        return {
            tableData:{
                 toolbox: {
            show: true,
            showTitle: false, // 隐藏默认文字，否则两者位置会重叠
            top: '-5',
            right: "50",
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },

              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },
            tooltip: { // 和 option.tooltip 的配置项相同
              show: true,
              formatter: function(param) {
                return '<div>'+param.title+'</div>'; // 自定义的 DOM 结构
              },
              backgroundColor: '#fff',
              textStyle: {
                fontSize: 12,
              },
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            }
                },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                        type: 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                        type: 'category',
                        data: ['6-15', '6-16', '6-17', '6-18', '6-19', '6-20', '6-21','6-22','6-23','6-24','6-25','6-26','6-27'],
                        axisTick: {
                            alignWithLabel: true
                        }
                        }
                    ],
                    yAxis: [
                        {
                        type: 'value'
                        }
                    ],
                    legend: {
                        data: ["发电量","收益"],
                        top: 10,
                        icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
                        itemWidth: 10, // 设置宽度
                        itemHeight: 10, // 设置高度
                        itemGap: 30, // 设置间距
                    },
                    series: [
                        {
                        name: '发电量',
                        type: 'bar',
                        itemStyle: {
                            color: '#1adbef'
                        },
                        barWidth: '60%',
                        data: [102, 520, 200, 334, 390, 330, 220,300,153,952,266,246,261]
                        },
                        
                        {
                        name: '收益',
                        type: 'line',
                        
                        data: [52, 120, 60, 60, 70, 30, 25,30,60,160,80,50,30]
                        }
                    ]
                    },
            value2:new Date(),
             options: [{
                value: 'date',
                label: '日'
                }, {
                value: 'month',
                label: '月'
                }, {
                value: 'year',
                label: '年'
                }],
                value: 'month',
            heights: document.getElementById('app').clientHeight-300,//屏幕高度 - 导航栏高度
        };
    },

    mounted() {
        this.init()
    },

    methods: {
         init () {
        // 饼图
     

       

        
        //中间柱状图
        middle3=echarts.init(document.getElementById("middle3"));
        middle3.setOption(this.tableData,true);
        middle3.resize();
     
      },
    },
};
</script>

<style lang="scss" scoped>
   .guangfu-tongyi {
      
   }
</style>